/* JVSG Store — comportamiento mínimo (sin dependencias)
   · Panel lateral de navegación (patrón Senawa, como jvsg.es): al abrirlo, la página se
     desvanece y queda solo la foto del mar (lo hace la hoja de estilos con .nav-open)
   · Botón «Volver arriba» (todas las páginas menos la portada), como en jvsg.es
   · Variantes: precio actualizado y enlace con ?variant=
   · Barra fija de compra en móvil
   · Contacto: rellena «Servicio» desde ?servicio=
   · Cesta: actualizar al cambiar cantidades */
(function () {
  'use strict';
  var body = document.body;

  /* ---------- Panel lateral ---------- */
  var burger = document.querySelector('.burger');
  var drawer = document.getElementById('nav-drawer');
  var backdrop = document.querySelector('[data-nav-backdrop]');

  if (burger && drawer) {
    var open = false;
    var inertTargets = [document.getElementById('main'), document.querySelector('.site-footer'), document.querySelector('.site-header__right'), document.querySelector('.sticky-cta'), document.querySelector('[data-to-top]')];

    var focusables = function () {
      return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea'));
    };

    var setOpen = function (value) {
      open = value;
      body.classList.toggle('nav-open', open);
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? burger.dataset.labelClose : burger.dataset.labelOpen);
      inertTargets.forEach(function (el) {
        if (!el) return;
        if (open) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
      if (open) {
        var f = focusables();
        if (f.length) setTimeout(function () { f[0].focus(); }, 380);
      } else {
        burger.focus();
      }
    };

    burger.addEventListener('click', function () { setOpen(!open); });
    if (backdrop) backdrop.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    drawer.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (a && a.getAttribute('href').charAt(0) === '#') setOpen(false);
    });
  }

  /* ---------- Volver arriba ---------- */
  var toTop = document.querySelector('[data-to-top]');
  if (toTop) {
    toTop.hidden = false;
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var ticking = false;
    /* Aparece al bajar algo más de media pantalla. Sobre la foto va en blanco, como en la web;
       si queda encima de una tarjeta blanca (ficha, cesta, formulario) o de una foto de producto
       (camisetas sobre fondo claro) cambia a trazo oscuro para que no desaparezca. */
    var updateToTop = function () {
      ticking = false;
      var visible = (window.scrollY || window.pageYOffset) > window.innerHeight * 0.6;
      toTop.classList.toggle('is-visible', visible);
      if (!visible || !document.elementsFromPoint) return;
      var r = toTop.getBoundingClientRect();
      var hits = document.elementsFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      var onPaper = Array.prototype.some.call(hits, function (el) {
        return el !== toTop && !toTop.contains(el) && el.closest && el.closest('.paper, .sticky-cta, .card__media, .pmedia__item');
      });
      toTop.classList.toggle('to-top--ink', !!onPaper);
    };
    var requestToTop = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateToTop);
    };
    window.addEventListener('scroll', requestToTop, { passive: true });
    window.addEventListener('resize', requestToTop);
    window.addEventListener('load', requestToTop);
    updateToTop();
    toTop.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: reduceMotion && reduceMotion.matches ? 'auto' : 'smooth' });
      if (burger) burger.focus({ preventScroll: true });
    });
  }

  /* ---------- Variantes ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-product]'), function (product) {
    var radios = product.querySelectorAll('input[type="radio"][name="id"]');
    if (!radios.length) return;
    var proposalSelect = product.querySelector('[data-proposal-variant]');
    var buttons = product.querySelectorAll('button[name="add"]');

    var update = function (radio) {
      var html = radio.getAttribute('data-price-html');
      if (html) {
        Array.prototype.forEach.call(product.querySelectorAll('[data-price-wrap]'), function (wrap) { wrap.innerHTML = html; });
      }
      var available = !radio.disabled;
      Array.prototype.forEach.call(buttons, function (b) { b.disabled = !available; });
      if (proposalSelect) {
        var title = radio.getAttribute('data-variant-title');
        Array.prototype.forEach.call(proposalSelect.options, function (o) { o.selected = (o.value === title); });
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());
      }
    };

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) update(radio); });
    });
  });

  /* ---------- Barra fija de compra en móvil ---------- */
  var buybox = document.querySelector('[data-buybox]');
  var sticky = document.querySelector('[data-sticky-cta]');
  if (buybox && sticky && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var proposal = document.getElementById('propuesta');
    var buyboxVisible = true, proposalVisible = false;
    var render = function () {
      var show = !buyboxVisible && !proposalVisible;
      sticky.classList.toggle('is-visible', show);
      body.classList.toggle('has-sticky-cta', show && window.innerWidth < 900);
    };
    new IntersectionObserver(function (entries) {
      buyboxVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      render();
    }, { threshold: 0 }).observe(buybox);
    if (proposal) {
      new IntersectionObserver(function (entries) { proposalVisible = entries[0].isIntersecting; render(); }, { threshold: 0 }).observe(proposal);
    }
  }

  /* ---------- Contacto: servicio desde la URL ---------- */
  var serviceField = document.querySelector('[data-service-field]');
  if (serviceField) {
    try {
      var params = new URLSearchParams(window.location.search);
      var s = params.get('servicio') || params.get('service');
      if (s && !serviceField.value) serviceField.value = s;
    } catch (e) {}
  }

  /* ---------- Cesta: actualizar cantidades ---------- */
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    var updateBtn = cartForm.querySelector('button[name="update"]');
    Array.prototype.forEach.call(cartForm.querySelectorAll('[data-cart-qty]'), function (input) {
      input.addEventListener('change', function () {
        if (updateBtn && cartForm.requestSubmit) cartForm.requestSubmit(updateBtn);
        else if (updateBtn) updateBtn.click();
      });
    });
  }
})();
